import React from 'react';
import { Touchable, type TouchableProps } from './Touchable';

export interface PrimaryButtonProps extends Omit<TouchableProps, 'haptic'> {
  size?: 'md' | 'lg';
}

const BASE_MD =
  'w-full py-3 rounded-2xl bg-primary text-white font-bold disabled:opacity-50 active:scale-[0.98] transition-all';

const BASE_LG =
  'relative flex items-center justify-center gap-3 h-20 bg-primary text-white rounded-3xl shadow-lg dark:shadow-none active:scale-[0.97] active:bg-primary-strong transition-all touch-manipulation';

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  size = 'md',
  className,
  ...rest
}) => {
  const base = size === 'lg' ? BASE_LG : BASE_MD;
  return <Touchable haptic="tap" className={className ? `${base} ${className}` : base} {...rest} />;
};
